module.exports = __webpack_public_path__ + "img/usdoicon@2x.eb9de4c9.png";